import { FlexGrid } from '@grapecity/wijmo.grid';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1300Component } from './kymw1300.component';
import { KYMW1300SelectedListComponent } from './kymw1300-selected-list/kymw1300-selected-list.component';
import { KYMW1300SelectTargetTabModel } from './vo/kymw1300-select-target-tab.model';
import { KYMW1300SelectedListModel } from './vo/kymw1300-selected-list.model';
import { KYMW1300GetPlanNumListModel } from './vo/kymw1300-get-plan-num-list.model';
import { KYMW1300CatalogProgressModel } from './vo/kymw1300-catalog-progress.model';
import { KYMW1300GetSearchSelectedListModel } from './vo/kymw1300-get-search-selected-list.model';
import { KYMW1300RegistPlanModel } from './vo/kymw1300-regist-plan.model';
import { KYMW1300DeletePlanModel } from './vo/kymw1300-delete-plan.model';
import { KYMW1300UpdateNextGuideAutoModel } from './vo/kymw1300-update-next-guide-auto.model';
import { KYMW1307InputModel } from '../kymw1307/vo/kymw1307-input.model';
import { KYMW1308InputModel } from '../kymw1308/vo/kymw1308-input.model';
import { KYMW1310InputModel } from '../kymw1310/vo/kymw1310-input.model';
import { KYMW1312InputModel } from '../kymw1312/vo/kymw1312-input.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { KYMW0500InputModel } from '../../../commons/kymw05/kymw0500/vo/kymw0500-input.model';
import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW0900InputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { KYMW1317InputModel } from '../kymw1317/vo/kymw1317-input.model';
import { Injectable } from "@angular/core";
import { CatalogInfoModel } from './vo/catalog-info.model';
import { BundleCatalogRoundInfoListModel } from './vo/bundle-catalog-round-info-list.model';
import { KYMW1300GetPlanTargetListModel } from './vo/kymw1300-get-plan-target-list.model';
import { MediumTypeModel } from './vo/medium-type.model';
import { KYMW1318InputModel } from '../kymw1318/vo/kymw1318-input.model';
import { KYMW0001OutputModel } from 'src/app/commons/kymw00/kymw0001/vo/kymw0001-output.model';
import { KYMW0002OutputModel } from 'src/app/commons/kymw00/kymw0002/vo/kymw0002-output.model';
import { KYMW1319InputVO } from '../kymw1319/vo/kymw1319-inputVO.model';


/**
 * 商品企画マスタ画面の値を管理するクラス
 *
 * @export KYMW1300Model
 * @class KYMW1300Model
 */
@Injectable()
export class KYMW1300Model {

  kymw1300Component: KYMW1300Component;

  /**
   * ボタン画像（編集ロック）
   *
   * @type {string}
   * @memberof KYMW1300Model
   */
  public srcLock = String('./assets/icons/KYMW14/lock.png');

  /**
   * ボタン画像（表示切替）
   *
   * @type {string}
   * @memberof KYMW1300Model
   */
  public srcDisp = String('./assets/icons/KYMW13/ViewCtrl.png');

  // 画面制御用
  public topTargetDiv = Number(140);                                    // 選定候補一覧・Div・上位置
  public heightTargetDiv = Number(356);                                 // 選定候補一覧・Div・高さ
  public heightTargetTab = Number(310);                                 // 選定候補一覧・Tab・高さ
  public heightTargetTabDiv = Number(282);                              // 選定候補一覧・TabDiv・高さ
  public heightTargetGrid = Number(190);                                // 選定候補一覧・Grid・高さ

  public topSelectedDiv = Number(500);                                  // 選定済一覧・Div・上位置
  public heightSelectedDiv = Number(346);                               // 選定済一覧・Div・高さ
  public heightSelectedGrid = Number(220);                              // 選定済一覧・Grid・高さ

  public catalogProgress: Array<KYMW1300CatalogProgressModel>                   // 企画進捗管理
    = new Array<KYMW1300CatalogProgressModel>();
  public catalogProgressBundle: Array<KYMW1300CatalogProgressModel>             // 企画進捗管理（束ね企画入力時）
    = new Array<KYMW1300CatalogProgressModel>();
  public orderNumQuotaCode: string = <string>'';                                // 注文コード割当コード

  public targetPCode: string = <string>'';                                      // 選定済一覧 選択Ｐコード

  public editLock: boolean = <boolean>false;                                    // 編集ロック
  public lockOrderCode: string = <string>'';                                    // 排他情報・受注コード
  public lockMediumType: string = <string>'';                                   // 排他情報・媒体区分
  public lockPCode: string = <string>'';                                        // 排他情報・Ｐコード
  public lockPCode_KYMW0800: string = <string>'';                               // 排他情報・Ｐコード・KYMW0800画面
  public senteiFlg: string = <string>'1';                                       // 「選定」クリックフラグ
  public cntDispChange: number = <number>1;                                     // 表示切替カウンタ(1：選定候補＋選定済、2：選定候補、3：選定済)
  public displayItem: string = <string>'1';                                     // 表示項目
  public enabledBundleCatalogGuideStandardName: boolean = <boolean>false;       // 束ね企画名　活性非活性フラグ
  public bundleCatalogRoundInfoList: Array<BundleCatalogRoundInfoListModel> = new Array<BundleCatalogRoundInfoListModel>();
  public BundleCatalogRoundId: string = <string>'';
  public BundleCatalogFlag: string = <string>'';
  public enabledBundleCatalogRound: boolean = <boolean>false;                   // ラジオボタン 束ね企画回への選定 初期表示：非活性
  public enabledSingleBundleCatalogRound: boolean = <boolean>false;             // ラジオボタン 単企画回への選定   初期表示：非活性
  public errList: Array<any> = new Array<any>();
  public componentOrderCode: string = <string>'';                               // 共通コンポーネントに使用される受注コード
  public tagOutput: KYMW0002OutputModel;                                        // タグ再表示用
  public goodsMarkOutput: KYMW0001OutputModel;                                  // 商品マーク再表示用
  public catalogId: string = <string>'';                                        // 企画回再表示用
  public catalogMarkOutput: KYMW0001OutputModel;                                // 企画マーク再表示用
  public pageInput: string = <string>'';                                                // ページ再表示用
  public currentContext: string = null;                                      // 実績履歴画面呼出元判断用

  // 商品選定・選定解除処理用リスト
  public registPlanVO: KYMW1300RegistPlanModel = new KYMW1300RegistPlanModel();
  public deletePlanVO: KYMW1300DeletePlanModel = new KYMW1300DeletePlanModel();
  public lockList: Array<string> = new Array<string>();
  public selectedBundleCatalogRoundInfoList: Array<BundleCatalogRoundInfoListModel> = new Array<BundleCatalogRoundInfoListModel>();

  // 画面バインド用変数
  public orderCode: string = <string>'';                                        // 受注コード
  public mediumType: string = <string>'';                                       // 媒体区分
  public sellAreaCode: string = <string>'';                                     // 売場コード
  public featureCodeList: Array<any> = new Array<any>();                        // 特集コード
  public mediumTypeList: MediumTypeModel[] = [];                                // 媒体リスト
  public bundleCatalogGuideStandardName: string = <string>'';                   // 束ね企画名
  public startOrderCode: string = <string>'';                                   // 束ね企画開回始受注コード
  public delivCatalogIdOfStartOrderCode: string = <string>'';                   // 束ね企画開回始受注コードに紐づく配達企画回
  public endOrderCode: string = <string>'';                                     // 束ね企画終了受注コード
  public radioGroup: string = <string>'';                                       // 束ね企画回への選定、単企画回への選定
  public featureCode: string = <string>'';                                      // 特集コード

  public delivCatalogId: string = null;                                         // 営業カレンダー・配達企画回
  public distributionStartDate: string = null;                                  // 営業カレンダー・配布開始日
  public distributionEndDate: string = null;                                    // 営業カレンダー・配布終了日
  public delivStartDate: string = null;                                         // 営業カレンダー・配達開始日
  public delivEndDate: string = null;                                           // 営業カレンダー・配達終了日
  public catalogTempFixDate: string = null;                                     // 営業カレンダー・企画仮確定日
  public catalogScheduleContactDate: string = null;                             // 営業カレンダー・予定連絡日
  public pdfSendDate: string = null;                                            // 営業カレンダー・PDF送信日
  public usedNumIB: string = null;                                              // 利用人数・計画・い
  public usedNumTO: string = null;                                              // 利用人数・計画・と
  public usedNumGU: string = null;                                              // 利用人数・計画・ぐ
  public usedNumTI: string = null;                                              // 利用人数・計画・ち
  public usedNumSA: string = null;                                              // 利用人数・計画・さ
  public usedNumTK: string = null;                                              // 利用人数・計画・とう
  public usedNumNA: string = null;                                              // 利用人数・計画・な
  public usedNumNI: string = null;                                              // 利用人数・計画・に

  public delivCatalogIdBundle: string = null;                                   // 営業カレンダー・配達企画回（束ね企画入力時）
  public distributionStartDateBundle: string = null;                            // 営業カレンダー・配布開始日（束ね企画入力時）
  public distributionEndDateBundle: string = null;                              // 営業カレンダー・配布終了日（束ね企画入力時）
  public delivStartDateBundle: string = null;                                   // 営業カレンダー・配達開始日（束ね企画入力時）
  public delivEndDateBundle: string = null;                                     // 営業カレンダー・配達終了日（束ね企画入力時）
  public catalogTempFixDateBundle: string = null;                               // 営業カレンダー・企画仮確定日（束ね企画入力時）
  public catalogScheduleContactDateBundle: string = null;                       // 営業カレンダー・予定連絡日（束ね企画入力時）
  public pdfSendDateBundle: string = null;                                      // 営業カレンダー・PDF送信日（束ね企画入力時）
  public usedNumIBBundle: string = null;                                        // 利用人数・計画・い（束ね企画入力時）
  public usedNumTOBundle: string = null;                                        // 利用人数・計画・と（束ね企画入力時）
  public usedNumGUBundle: string = null;                                        // 利用人数・計画・ぐ（束ね企画入力時）
  public usedNumTIBundle: string = null;                                        // 利用人数・計画・ち（束ね企画入力時）
  public usedNumSABundle: string = null;                                        // 利用人数・計画・さ（束ね企画入力時）
  public usedNumTKBundle: string = null;                                        // 利用人数・計画・とう（束ね企画入力時）
  public usedNumNABundle: string = null;                                        // 利用人数・計画・な（束ね企画入力時）
  public usedNumNIBundle: string = null;                                        // 利用人数・計画・に（束ね企画入力時）

  public lastTimeGetSelectedListVO: KYMW1300GetSearchSelectedListModel = null;  // 選定済一覧取得APIの前回検索条件

  /**
   * 一覧のクリア処理
   *
   * @memberof KYMW1300Model
   */
  public clearList(): void {
    this.delivCatalogId = null;                                                 // 営業カレンダー・配達企画回
    this.distributionStartDate = null;                                          // 営業カレンダー・配布開始日
    this.distributionEndDate = null;                                            // 営業カレンダー・配布終了日
    this.delivStartDate = null;                                                 // 営業カレンダー・配達開始日
    this.delivEndDate = null;                                                   // 営業カレンダー・配達終了日
    this.catalogTempFixDate = null;                                             // 営業カレンダー・企画仮確定日
    this.catalogScheduleContactDate = null;                                     // 営業カレンダー・予定連絡日
    this.pdfSendDate = null;                                                    // 営業カレンダー・PDF送信日
    this.usedNumIB = null;                                                      // 利用人数・計画・い
    this.usedNumTO = null;                                                      // 利用人数・計画・と
    this.usedNumGU = null;                                                      // 利用人数・計画・ぐ
    this.usedNumTI = null;                                                      // 利用人数・計画・ち
    this.usedNumSA = null;                                                      // 利用人数・計画・さ
    this.usedNumTK = null;                                                      // 利用人数・計画・とう
    this.usedNumNA = null;                                                      // 利用人数・計画・な
    this.usedNumNI = null;                                                      // 利用人数・計画・に
    this.catalogProgress = new Array<KYMW1300CatalogProgressModel>();           // 企画進捗管理
  }

  /**
   * 一覧のクリア処理（束ね企画）
   *
   * @memberof KYMW1300Model
   */
  public clearBundleList(): void {
    this.delivCatalogIdBundle = null;
    this.distributionStartDateBundle = null;
    this.distributionEndDateBundle = null;
    this.delivStartDateBundle = null;
    this.delivEndDateBundle = null;
    this.catalogTempFixDateBundle = null;
    this.catalogScheduleContactDateBundle = null;
    this.pdfSendDateBundle = null;
    this.usedNumIBBundle = null;
    this.usedNumTOBundle = null;
    this.usedNumGUBundle = null;
    this.usedNumTIBundle = null;
    this.usedNumSABundle = null;
    this.usedNumTKBundle = null;
    this.usedNumNABundle = null;
    this.usedNumNIBundle = null;
    this.catalogProgressBundle = new Array<KYMW1300CatalogProgressModel>();
  }

  /**
   * 束ね企画の企画管理情報の反映処理
   * 
   * @memberof KYMW1300Model
   */
  public displayBundleCatalogInfo() {
    this.delivCatalogId = this.delivCatalogIdBundle;
    this.distributionStartDate = this.distributionStartDateBundle;
    this.distributionEndDate = this.distributionEndDateBundle;
    this.delivStartDate = this.delivStartDateBundle;
    this.delivEndDate = this.delivEndDateBundle;
    this.catalogTempFixDate = this.catalogTempFixDateBundle;
    this.catalogScheduleContactDate = this.catalogScheduleContactDateBundle;
    this.pdfSendDate = this.pdfSendDateBundle;
    this.usedNumIB = this.usedNumIBBundle;
    this.usedNumTO = this.usedNumTOBundle;
    this.usedNumGU = this.usedNumGUBundle;
    this.usedNumTI = this.usedNumTIBundle;
    this.usedNumSA = this.usedNumSABundle;
    this.usedNumTK = this.usedNumTKBundle;
    this.usedNumNA = this.usedNumNABundle;
    this.usedNumNI = this.usedNumNIBundle;
    this.catalogProgress = this.catalogProgressBundle;
  }

  /**
   * 企画管理情報の反映処理
   * 
   * 受注コード有効時は画面表示は受注コード+媒体で取得したもの
   * 受注コード無効時かつ束ね企画時は画面表示は束ね企画の開始受注コード+媒体で取得したもの
   *
   * @param {*} data 企画管理情報取得APIレスポンス
   * @param {*} isValidOrderCode 受注コード有効フラグ
   * @param {*} isBundle 束ね企画入力時フラグ
   * @memberof KYMW1300Model
   */
  public updateCatalogInfo(data: CatalogInfoModel, isValidOrderCode: boolean, isBundle: boolean): void {
    if (isBundle) {
      // 束ね企画時は束ね企画用の変数で保持
      this.delivCatalogIdBundle = data.DelivCatalogId;
      this.distributionStartDateBundle = data.DistributionStartDate;
      this.distributionEndDateBundle = data.DistributionEndDate;
      this.delivStartDateBundle = data.DelivStartDate;
      this.delivEndDateBundle = data.DelivEndDate;
      this.catalogTempFixDateBundle = data.CatalogTempFixDate;
      this.catalogScheduleContactDateBundle = data.CatalogScheduleContactDate;
      this.pdfSendDateBundle = data.PdfSendDate;
      this.usedNumIBBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumIB, true);
      this.usedNumTOBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumTO, true);
      this.usedNumGUBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumGU, true);
      this.usedNumTIBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumTI, true);
      this.usedNumSABundle = PlessViewUtilsSub.editPriceComma(data.UsedNumSA, true);
      this.usedNumTKBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumTK, true);
      this.usedNumNABundle = PlessViewUtilsSub.editPriceComma(data.UsedNumNA, true);
      this.usedNumNIBundle = PlessViewUtilsSub.editPriceComma(data.UsedNumNI, true);
      this.catalogProgressBundle = new Array<KYMW1300CatalogProgressModel>();
      if (!PlessViewUtilsSub.isEmptyArray(data.CatalogProgress)) {
        for (const item of data.CatalogProgress) {
          const vo: KYMW1300CatalogProgressModel = new KYMW1300CatalogProgressModel();
          vo.MediumType = item.MediumType;
          vo.ProgressWorkNum = item.ProgressWorkNum;
          this.catalogProgressBundle.push(vo);
        }
      }

      if (!isValidOrderCode) {
        // 受注コード無効時は表示にも反映
        this.displayBundleCatalogInfo();
      }
    } else {
      // 束ね企画でない場合は常に表示に反映（この場合は常に受注コード有効）
      this.delivCatalogId = data.DelivCatalogId;
      this.distributionStartDate = data.DistributionStartDate;
      this.distributionEndDate = data.DistributionEndDate;
      this.delivStartDate = data.DelivStartDate;
      this.delivEndDate = data.DelivEndDate;
      this.catalogTempFixDate = data.CatalogTempFixDate;
      this.catalogScheduleContactDate = data.CatalogScheduleContactDate;
      this.pdfSendDate = data.PdfSendDate;
      this.usedNumIB = PlessViewUtilsSub.editPriceComma(data.UsedNumIB, true);
      this.usedNumTO = PlessViewUtilsSub.editPriceComma(data.UsedNumTO, true);
      this.usedNumGU = PlessViewUtilsSub.editPriceComma(data.UsedNumGU, true);
      this.usedNumTI = PlessViewUtilsSub.editPriceComma(data.UsedNumTI, true);
      this.usedNumSA = PlessViewUtilsSub.editPriceComma(data.UsedNumSA, true);
      this.usedNumTK = PlessViewUtilsSub.editPriceComma(data.UsedNumTK, true);
      this.usedNumNA = PlessViewUtilsSub.editPriceComma(data.UsedNumNA, true);
      this.usedNumNI = PlessViewUtilsSub.editPriceComma(data.UsedNumNI, true);
      this.catalogProgress = new Array<KYMW1300CatalogProgressModel>();
      if (!PlessViewUtilsSub.isEmptyArray(data.CatalogProgress)) {
        for (const item of data.CatalogProgress) {
          const vo: KYMW1300CatalogProgressModel = new KYMW1300CatalogProgressModel();
          vo.MediumType = item.MediumType;
          vo.ProgressWorkNum = item.ProgressWorkNum;
          this.catalogProgress.push(vo);
        }
      }
    }
  }

  /**
   * 工程管理NOのチェック
   * 指定の媒体区分の工程管理NOが「07：企画確定」以降はエラーとする。
   *
   * @private
   * @param {string} mediumType
   * @returns {boolean} チェック結果(true：正常、false：エラー)
   * @memberof KYMW1300Model
   */
  private checkProgressWorkNum(mediumType: string): boolean {
    let blnRet: boolean = <boolean>true;

    // 媒体区分のチェック
    if (!PlessViewUtilsSub.isEmpty(mediumType)) {                               // 指定ありの場合
      for (const item of this.catalogProgress) {
        // 媒体区分、工程管理NOのチェック
        if (item.MediumType === mediumType                                      // 同一媒体区分、
          && Number(item.ProgressWorkNum) >= 7) {                               // 「07：企画確定」以降の場合
          // チェック結果(false：エラー)を設定
          blnRet = false;
          break;
        }
      }
    }

    // チェック結果を返却
    return blnRet;
  }

  /**
   * 選定済一覧の選択Ｐコード取得
   *
   * @returns {String}
   * @memberof KYMW1300Model
   */
  public getSelectedPCode(): string {
    let retPCode: string = <string>'';

    // 選択行の有無チェック
    if (!PlessViewUtilsSub.isEmptyArray(this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selectedItems)) {
      retPCode = this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selectedItems[0].PCode;
    }

    // 選択Ｐコードを返却
    return retPCode;
  }

  /**
   * プロモーション設定判定
   * 指定のＰコードの商品に設定されているプロモーションの有無を返却する。
   *
   * @param {string} targetPCode
   * @returns {boolean} 判定結果(true：プロモーション設定されている、false：プロモーション設定されていない)
   * @memberof KYMW1300Model
   */
  public hasPromotionInfo(targetPCode: string): boolean {
    // プロモーション設定判定
    for (const item of this.kymw1300Component.kymw1300_03.selectedModel.selectedList) { // 選定済一覧要素数分ループ
      // リストの要素のＰコードと引数のＰコードを比較
      if (item.PCode === targetPCode) {                                      // 同一Ｐコードの場合
        // 各生協のプロモーションＮＯのチェック
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoIB)                   // 「いばらき」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoTO)                  // 「とちぎ」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoGU)                  // 「ぐんま」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoTI)                  // 「ちば」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoSA)                  // 「さいたま」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoTK)                  // 「とうきょう」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoNA)                  // 「ながの」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoNI)                  // 「にいがた」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.PromotionNoKU)) {               // 「クルコ」で指定ありの場合
          // 判定結果を返却
          return true;
        }
      }
    }

    // 判定結果を返却
    return false;
  }

  /**
   * セット企画プロモーション設定判定
   * 指定のＰコードの商品に設定されているセット企画プロモーションの有無を返却する。
   *
   * @param {string} targetPCode
   * @returns {boolean} 判定結果(true：セット企画プロモーション設定されている、false：セット企画プロモーション設定されていない)
   * @memberof KYMW1300Model
   */
  public hasSetPromotionInfo(targetPCode: string): boolean {
    // セット企画プロモーション設定判定
    for (const item of this.kymw1300Component.kymw1300_03.selectedModel.selectedList) { // 選定済一覧要素数分ループ
      // リストの要素のＰコードと引数のＰコードを比較
      if (item.PCode === targetPCode) {                                      // 同一Ｐコードの場合
        // 各生協のセット企画プロモーションＮＯのチェック
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoIB)                // 「いばらき」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoTO)               // 「とちぎ」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoGU)               // 「ぐんま」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoTI)               // 「ちば」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoSA)               // 「さいたま」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoTK)               // 「とうきょう」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoNA)               // 「ながの」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoNI)               // 「にいがた」で指定ありの場合
          || !PlessViewUtilsSub.isEmpty(item.SetPromotionNoKU)) {            // 「クルコ」で指定ありの場合
          // 判定結果を返却
          return true;
        }
      }
    }

    // 判定結果を返却
    return false;
  }

  /**
   * プロモーションＮＯ取得
   * 指定のＰコードの商品に設定されているプロモーションＮＯを返却する。
   *
   * @param {string} targetPCode
   * @returns {string}
   * @memberof KYMW1300Model
   */
  public getPromotionInfo(targetPCode: string): string {
    // プロモーションＮＯ取得
    for (const item of this.kymw1300Component.kymw1300_03.selectedModel.selectedList) { // 選定済一覧要素数分ループ
      // リストの要素のＰコードと引数のＰコードを比較
      if (item.PCode === targetPCode) {                                      // 同一Ｐコードの場合
        // 各生協のプロモーションＮＯのチェック
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoIB)) {                // 「いばらき」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoIB;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoTO)) {                // 「とちぎ」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoTO;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoGU)) {                // 「ぐんま」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoGU;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoTI)) {                // 「ちば」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoTI;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoSA)) {                // 「さいたま」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoSA;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoTK)) {                // 「とうきょう」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoTK;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoNA)) {                // 「ながの」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoNA;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoNI)) {                // 「にいがた」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoNI;
        }
        if (!PlessViewUtilsSub.isEmpty(item.PromotionNoKU)) {                // 「クルコ」で指定ありの場合
          // プロモーションＮＯを返却
          return item.PromotionNoKU;
        }
      }
    }

    // プロモーションＮＯを返却
    return '';
  }

  /**
   * セット企画プロモーションＮＯ取得
   * 指定のＰコードの商品に設定されているセット企画プロモーションＮＯを返却する。
   *
   * @param {string} targetPCode
   * @returns {string}
   * @memberof KYMW1300Model
   */
  public getSetPromotionInfo(targetPCode: string): string {
    // セット企画プロモーションＮＯ取得
    for (const item of this.kymw1300Component.kymw1300_03.selectedModel.selectedList) { // 選定済一覧要素数分ループ
      // リストの要素のＰコードと引数のＰコードを比較
      if (item.PCode === targetPCode) {                                      // 同一Ｐコードの場合
        // 各生協のセット企画プロモーションＮＯのチェック
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoIB)) {             // 「いばらき」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoIB;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoTO)) {             // 「とちぎ」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoTO;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoGU)) {             // 「ぐんま」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoGU;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoTI)) {             // 「ちば」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoTI;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoSA)) {             // 「さいたま」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoSA;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoTK)) {             // 「とうきょう」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoTK;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoNA)) {             // 「ながの」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoNA;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoNI)) {             // 「にいがた」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoNI;
        }
        if (!PlessViewUtilsSub.isEmpty(item.SetPromotionNoKU)) {             // 「クルコ」で指定ありの場合
          // セット企画プロモーションＮＯを返却
          return item.SetPromotionNoKU;
        }
      }
    }

    // セット企画プロモーションＮＯを返却
    return '';
  }


  // VO初期化 START

  /**
   * 紐付設定画面InputVO初期化
   *
   * @returns {KYMW0500InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW0500InputVO(): KYMW0500InputModel {
    const returnVO: KYMW0500InputModel = new KYMW0500InputModel();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.editMode = this.editLock;                                          // 編集モード
    returnVO.mediumType =
      this.kymw1300Component.kymw1300_03.selectedModel.
        selectedList[this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selection.row].MediumType; // 媒体区分
    returnVO.processDiv = '2';                                                  // 処理区分(2：商品企画マスタから起動)

    const grid: FlexGrid = this.kymw1300Component.kymw1300_03.dg_SelectedItemList;
    const relateMasterCode: string = grid.selectedItems[0].RelateMasterCode;
    const pCode: string = grid.selectedItems[0].PCode;

    // 連携マスタコードのチェック
    if (!PlessViewUtilsSub.isEmpty(relateMasterCode)) {                         // 指定ありの場合
      returnVO.mainPCode = relateMasterCode;                                    // 代表商品コード(連携マスタコードを設定)
    } else {                                                                    // 指定なしの場合
      returnVO.mainPCode = pCode;                                               // 代表商品コード(Ｐコードを設定)
    }

    return returnVO;
  }

  /**
   * 実績履歴画面InputVO初期化
   *
   * @param {string} [context] 呼出元(targetList：選定候補一覧、selectedList：選定済一覧)
   * @returns {KYMW0800InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW0800InputVO(context: string): KYMW0800InputModel {
    this.currentContext = context;
    let grid: FlexGrid = null;

    const returnVO: KYMW0800InputModel = new KYMW0800InputModel();
    let mediumType: string = <string>'';
    let pCode: string = <string>'';
    let goodsName: string = <string>'';
    let standardName: string = <string>'';

    // 選定候補一覧
    if (this.currentContext === 'targetList') {
      grid = this.kymw1300Component.kymw1300_02.dg_SelectTargetList;
    // 選定済一覧
    } else if (this.currentContext === 'selectedList') {
      grid = this.kymw1300Component.kymw1300_03.dg_SelectedItemList;
    }

    // 選定候補一覧または選定済一覧の選択行のチェック
    if (!PlessViewUtilsSub.isEmptyArray(grid.selectedItems)) {
      mediumType = grid.selectedItems[0].MediumType;
      pCode = grid.selectedItems[0].PCode;
      goodsName = grid.selectedItems[0].GuideGoodsName;
      standardName = grid.selectedItems[0].GuideStandardName;
    }

    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.funcID = 'KYMW1300';
    returnVO.mediumType = mediumType;

    returnVO.pCodeList = new Array<any>();
    if (!PlessViewUtilsSub.isEmpty(pCode)) {
      returnVO.pCodeList.push({ PCode: pCode, GuideGoodsName: goodsName, GuideStandardName: standardName });
    }

    // 実績履歴画面InputVOを返却
    return returnVO;
  }

  /**
   * 商品企画メンテナンス画面InputVO初期化
   *
   * @returns {KYMW0900InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW0900InputVO(): KYMW0900InputModel {
    const returnVO: KYMW0900InputModel = new KYMW0900InputModel();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.pCodeList.push(this.getSelectedPCode());
    returnVO.MediumType =
      this.kymw1300Component.kymw1300_03.selectedModel.
        selectedList[this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selection.row].MediumType; // 媒体区分
    if (!this.kymw1300Component.kymw00Model.kymw1001Model.topFuncReadOnlyMode) {
      returnVO.UserPermission = '0';
    } else {
      returnVO.UserPermission = '1';
    }

    return returnVO;
  }

  /**
   * 予算・計画・実績表画面InputVO初期化
   *
   * @returns {KYMW1307InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1307InputVO(): KYMW1307InputModel {

    const model: KYMW1300SelectedListModel = this.kymw1300Component.kymw1300_03.selectedModel;
    const returnVO: KYMW1307InputModel = new KYMW1307InputModel();

    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.displayMode = model.accessDispMode;
    returnVO.mediumType = this.mediumType;
    returnVO.sellAreaCode = this.sellAreaCode;
    returnVO.orderNumQuotaCode = model.accessOrderNumQuotaCode;
    returnVO.coopCode = model.accessCoopCode;
    returnVO.classCode = model.accessClassCode;
    returnVO.middleClassCode = model.accessMiddleClassCode;
    returnVO.smallClassCode = model.accessSmallClassCode;
    returnVO.buyerCode = model.accessBuyerCode;
    returnVO.orderClientCode = model.orderClientCode;
    returnVO.orderClientKanji = model.orderClientKanji;
    returnVO.payeeClientCode = model.payeeClientCode;
    returnVO.payeeClientKanji = model.payeeClientKanji;

    // ページ番号のチェック
    if (model.accessPageNo === '*' || model.accessPageNo === 'ALL') {           // 『全ページ』の場合
      returnVO.pageNum = '';
      returnVO.nonCarryFlag = '0';
    } else if (model.accessPageNo === '-' || model.accessPageNo === 'NOT') {    // 『非掲載』の場合
      returnVO.pageNum = '';
      returnVO.nonCarryFlag = '1';
    } else {                                                                    // 上記以外の場合
      returnVO.pageNum = model.accessPageNo;
      returnVO.nonCarryFlag = '';
    }

    return returnVO;
  }

  /**
   * バンドルミックスマッチ設定画面InputVO初期化
   *
   * @returns {KYMW1308InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1308InputVO(): KYMW1308InputModel {
    const returnVO: KYMW1308InputModel = new KYMW1308InputModel();
    returnVO.accessDiv = '1';                                                   // 処理区分(1：バンドルミックスマッチ設定)
    returnVO.editLock = this.kymw1300Component.getIcnEditLock();
    returnVO.mediumType = this.mediumType;
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    return returnVO;
  }

  /**
   * Ｗ掲載設定画面InputVO初期化
   *
   * @returns {KYMW1310InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1310InputVO(): KYMW1310InputModel {
    const returnVO: KYMW1310InputModel = new KYMW1310InputModel();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.pCode = this.getSelectedPCode();
    returnVO.editLock = this.kymw1300Component.getIcnEditLock();
    return returnVO;
  }

  /**
   * セット企画設定画面InputVO初期化
   *
   * @param {string} [type='0'] 初期化区分(0：商品選択なし、1：商品選択あり)
   * @returns {KYMW1312InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1312InputVO(div = '0'): KYMW1312InputModel {
    const returnVO: KYMW1312InputModel = new KYMW1312InputModel();
    returnVO.accessDiv = '1';                                                   // 処理区分(1：セット企画設定)
    returnVO.editLock = this.kymw1300Component.getIcnEditLock();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }

    // 初期化区分のチェック
    if (div === '1') {                                                         // 「1：商品選択あり」の場合
      returnVO.pCodeList.push(this.targetPCode);
      returnVO.promotionNo = this.getSetPromotionInfo(this.targetPCode);
    }

    returnVO.isGroupNormal = this.isGroupNormal();

    return returnVO;
  }

  /**
   *  受注コード指定選定解除画面InputVO初期化
   *
   * @returns {KYMW1318InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1318InputVO(orderCodeSpecifyDeletePlanList: Array<any>): KYMW1318InputModel {
    const returnVO: KYMW1318InputModel = new KYMW1318InputModel();
    returnVO.pCode = orderCodeSpecifyDeletePlanList[0].PCode;
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.guideGoodsName = orderCodeSpecifyDeletePlanList[0].GuideGoodsName;
    returnVO.guideStandardName = orderCodeSpecifyDeletePlanList[0].GuideStandardName;
    returnVO.mediumType = this.mediumType;
    returnVO.mediumTypeList = this.mediumTypeList;
    
    return returnVO;
  }

  /**
   * 予算・計画数一覧検索条件VO初期化
   *
   * @returns {KYMW1300GetPlanNumListModel}
   * @memberof KYMW1300Component
   */
  public setGetPlanNumListVO(): KYMW1300GetPlanNumListModel {
    const kymw1300_03Cmp: KYMW1300SelectedListComponent = this.kymw1300Component.kymw1300_03;
    const selectedMdl: KYMW1300SelectedListModel = kymw1300_03Cmp.selectedModel;

    // 検索条件VO初期化
    const returnVO: KYMW1300GetPlanNumListModel = new KYMW1300GetPlanNumListModel();
    returnVO.dispMode = selectedMdl.accessDispMode;
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.mediumType = this.mediumType;
    returnVO.sellAreaCode = this.sellAreaCode;
    returnVO.orderNumQuotaCode = selectedMdl.orderNumQuotaCode;
    returnVO.coopCode = selectedMdl.accessCoopCode;
    returnVO.classCode = selectedMdl.accessClassCode;
    returnVO.middleClassCode = selectedMdl.accessMiddleClassCode;
    returnVO.smallClassCode = selectedMdl.accessSmallClassCode;
    returnVO.page = selectedMdl.accessPageNo;
    returnVO.buyerCode = selectedMdl.accessBuyerCode;
    returnVO.orderClientCode = selectedMdl.orderClientCode;
    returnVO.orderClientKanji = selectedMdl.orderClientKanji;
    returnVO.payeeClientCode = selectedMdl.payeeClientCode;
    returnVO.payeeClientKanji = selectedMdl.payeeClientKanji;

    // 検索条件VO初期化
    return returnVO;
  }

  /**
   * 選定候補一覧検索条件VO初期化
   *
   * @param {KYMW1300SelectTargetTabModel} targetTabMdl
   * @param {KYMW0300OutputModel} [outputVO=null]
   * @param {boolean} [refleshFlg=false]
   * @returns {KYMW1300GetPlanTargetListModel}
   * @memberof KYMW1300Model
   */
  public setGetPlanTargetListVO(targetTabMdl: KYMW1300SelectTargetTabModel,
    outputVO: KYMW0300OutputModel = null, refleshFlg = false): KYMW1300GetPlanTargetListModel {
    // 選定候補一覧検索条件VO初期化
    const returnVO: KYMW1300GetPlanTargetListModel = new KYMW1300GetPlanTargetListModel();

    // 受注コードが入力の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //　未入力の場合束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode;
    }
    returnVO.mediumType = this.mediumType;                                      // 媒体区分

    // 商品検索画面OutputVOのインスタンスチェック
    if (outputVO === null) {                                                    // 指定なしの場合
      returnVO.pcode = targetTabMdl.pcode;                                      // Ｐコード
      returnVO.itemCode = targetTabMdl.itemCode;                                // アイテムコード
      returnVO.janCode = targetTabMdl.janCode;                                  // ＪＡＮコード
      returnVO.makerName = targetTabMdl.makerName;                              // メーカー名
      returnVO.guideGoodsName = targetTabMdl.guideGoodsNameList;                // 商品案内用商品名
      returnVO.guideStandardName = targetTabMdl.guideStandardNameList;          // 商品案内用規格名
      returnVO.tagSearchType = targetTabMdl.tagSearchType;                      // タグ検索方法
      returnVO.goodsMark = targetTabMdl.goodsMark;                              // 商品マーク
      returnVO.goodsMarkSearchType = targetTabMdl.goodsMarkSearchType;          // 商品マーク検索方法
      returnVO.dataKbnFlg = targetTabMdl.dataKbnFlg;                            // 取扱終了商品を含む
      returnVO.goodsDiv = targetTabMdl.goodsDiv;                                // ダミー商品
      returnVO.buyerCode = targetTabMdl.buyerCode;                              // バイヤーコード
      returnVO.coopCode = targetTabMdl.coopCode;                                // 取扱可能生協
      returnVO.admitStatus = targetTabMdl.admitStatus;                          // 登録レベル(空：全体、eBASE取込後："0"、仮登録："1"、本登録："2")
      returnVO.registDateFrom = targetTabMdl.registDateFrom;                    // 登録日from
      returnVO.registDateTo = targetTabMdl.registDateTo;                        // 登録日to
      returnVO.updateDateFrom = targetTabMdl.updateDateFrom;                    // 更新日from
      returnVO.updateDateTo = targetTabMdl.updateDateTo;                        // 更新日to
      returnVO.classCode = targetTabMdl.classCode;                              // 部門
      returnVO.middleClassCode = targetTabMdl.middleClassCode;                  // 中分類
      returnVO.smallClassCode = targetTabMdl.smallClassCode;                    // 小分類
      returnVO.ordrClientCode = targetTabMdl.ordrClientCode;                    // 発注先コード
      returnVO.ordrClientKanji = targetTabMdl.ordrClientKanji;                  // 発注先名称
      returnVO.payeeClientCode = targetTabMdl.payeeClientCode;                  // 支払先コード
      returnVO.payeeClientKanji = targetTabMdl.payeeClientKanji;                // 支払先名称
      returnVO.searchMediumType = targetTabMdl.searchMediumType;                // 商品検索媒体区分
      returnVO.searchOrderCode = targetTabMdl.searchOrderCode;                  // 商品検索受注コード
      returnVO.specialFeature = targetTabMdl.specialFeature;                    // 特集コード
      returnVO.catalogCode = targetTabMdl.catalogCode;                          // 企画マーク
      returnVO.catalogCodeSearchType = targetTabMdl.catalogCodeSearchType;      // 企画マーク検索方法
      returnVO.pageNo = targetTabMdl.pageNo;                                    // ページNO
      returnVO.duties = targetTabMdl.duties;                                    // デイリー
      returnVO.tagId = targetTabMdl.tagId;                                      // タグ
      returnVO.pcodeList = targetTabMdl.pcodeList;                              // Pコードリスト
      returnVO.itemCodeList = targetTabMdl.itemCodeList;                        // アイテムコードリスト
      returnVO.searchKbn = targetTabMdl.searchKbn;                              // 検索区分（0:通常検索、1:リスト検索（Pコード）、2:リスト検索（アイテムコード））
    } else {                                                                    // 指定ありの場合
      returnVO.pcode = outputVO.pcode;                                          // Ｐコード
      returnVO.itemCode = outputVO.itemCode;                                    // アイテムコード
      returnVO.janCode = outputVO.janCode;                                      // ＪＡＮコード
      returnVO.makerName = outputVO.makerName;                                  // メーカー名
      returnVO.guideGoodsName = outputVO.guideGoodsNameList;                    // 商品案内用商品名
      returnVO.guideStandardName = outputVO.guideStandardNameList;              // 商品案内用規格名
      returnVO.tagSearchType = outputVO.tagSearchType;                          // タグ検索方法
      returnVO.goodsMark = outputVO.goodsMark;                                  // 商品マーク
      returnVO.goodsMarkSearchType = outputVO.goodsMarkSearchType;              // 商品マーク検索方法
      returnVO.dataKbnFlg = outputVO.dataKbnFlg;                                // 取扱終了商品を含む
      returnVO.goodsDiv = outputVO.goodsDiv;                                    // ダミー商品
      returnVO.buyerCode = outputVO.buyerCode;                                  // バイヤーコード
      returnVO.coopCode = outputVO.coopCodeList;                                // 取扱可能生協
      returnVO.admitStatus = outputVO.admitStatus;                              // 登録レベル(空：全体、eBASE取込後："0"、仮登録："1"、本登録："2")
      returnVO.registDateFrom = outputVO.registDateFrom;                        // 登録日from
      returnVO.registDateTo = outputVO.registDateTo;                            // 登録日to
      returnVO.updateDateFrom = outputVO.updateDateFrom;                        // 更新日from
      returnVO.updateDateTo = outputVO.updateDateTo;                            // 更新日to
      returnVO.classCode = outputVO.classCode;                                  // 部門
      returnVO.middleClassCode = outputVO.middleClassCode;                      // 中分類
      returnVO.smallClassCode = outputVO.smallClassCode;                        // 小分類
      returnVO.ordrClientCode = outputVO.ordrClientCode;                        // 発注先コード
      returnVO.ordrClientKanji = outputVO.ordrClientKanji;                      // 発注先名称
      returnVO.payeeClientCode = outputVO.payeeClientCode;                      // 支払先コード
      returnVO.payeeClientKanji = outputVO.payeeClientKanji;                    // 支払先名称
      returnVO.searchMediumType = outputVO.mediumType;                          // 商品検索媒体区分
      returnVO.searchOrderCode = outputVO.orderCode;                            // 商品検索受注コード
      returnVO.specialFeature = outputVO.specialFeature;                        // 特集コード
      returnVO.catalogCode = outputVO.catalogCode;                              // 企画マーク
      returnVO.catalogCodeSearchType = outputVO.catalogCodeSearchType;          // 企画マーク検索方法
      returnVO.pageNo = outputVO.pageNo;                                        // ページNO
      returnVO.duties = outputVO.duties;                                        // デイリー
      returnVO.tagId = outputVO.tagId;                                          // タグ
      returnVO.pcodeList = outputVO.pcodeList;                                  // Pコードリスト
      returnVO.itemCodeList = outputVO.itemcodeList;                            // アイテムコードリスト
      returnVO.tagOutput = outputVO.tagOutput;                                  // タグ再表示用  
      returnVO.goodsMarkOutput = outputVO.goodsMarkOutput;                      // 商品マーク再表示用  
      returnVO.catalogId = outputVO.catalogId;                                  // 企画回再表示用  
      returnVO.catalogMarkOutput = outputVO.catalogMarkOutput;                  // 企画マーク再表示用  
      returnVO.pageInput = outputVO.pageInput;                                  // ページ再表示用  
      returnVO.searchKbn = outputVO.searchKbn;                                  // 検索区分（0:通常検索、1:リスト検索（Pコード）、2:リスト検索（アイテムコード））
    }

    // 次へ前へボタン
    // 再表示フラグのチェック
    if (refleshFlg) {                                                           // 「true：再表示する」の場合
      returnVO.page = targetTabMdl.page;
      returnVO.sortItem = targetTabMdl.sortItem;
      returnVO.sortOrder = targetTabMdl.sortOrder;
    } else {                                                                    // 上記以外の場合
      returnVO.sortItem = targetTabMdl.sortItem;
      returnVO.sortOrder = targetTabMdl.sortOrder;
    }

    // 検索条件VOを返却
    return returnVO;
  }

  /**
   * 選定済一覧検索条件VO初期化
   *
   * @param {boolean} [refleshFlg=false] 再表示フラグ(true：再表示する、false：再表示しない)
   * @returns {KYMW1300GetSearchSelectedListModel}
   * @memberof KYMW1300Component
   */
  public setGetSelectedListVO(refleshFlg = false): KYMW1300GetSearchSelectedListModel {
    // 選定済一覧検索条件VO初期化
    const returnVO: KYMW1300GetSearchSelectedListModel = new KYMW1300GetSearchSelectedListModel();
    // 受注コードが入力の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //　未入力の場合束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode;
    }
    returnVO.mediumType = this.mediumType;
    returnVO.sellAreaCode = this.kymw1300Component.cmb_SellArea.selectedSellAreaCode;
    returnVO.orderNumQuotaCode = this.kymw1300Component.kymw1300_03.cmb_OrderNumQuota_Selected.selectedOrderNumQuotaCode;
    returnVO.nextGuideCheckFlg = this.kymw1300Component.kymw1300_03.selectedModel.accessNextGuideCheckFlg;
    returnVO.kikakuRenrakuStatus = this.kymw1300Component.kymw1300_03.selectedModel.kikakuRenrakuStatus;

    // 再表示フラグのチェック
    if (refleshFlg) {                                                           // 「true：再表示する」の場合
      const accessPage = this.kymw1300Component.kymw1300_03.selectedModel.accessPage;
      returnVO.dispMode = this.kymw1300Component.kymw1300_03.selectedModel.accessDispMode;
      returnVO.coopCode = this.kymw1300Component.kymw1300_03.selectedModel.accessCoopCode;
      returnVO.classCode = this.kymw1300Component.kymw1300_03.selectedModel.accessClassCode;
      returnVO.middleClassCode = this.kymw1300Component.kymw1300_03.selectedModel.accessMiddleClassCode;
      returnVO.smallClassCode = this.kymw1300Component.kymw1300_03.selectedModel.accessSmallClassCode;
      returnVO.pageNo = this.kymw1300Component.kymw1300_03.selectedModel.accessPageNo;
      returnVO.buyerCode = this.kymw1300Component.kymw1300_03.selectedModel.accessBuyerCode;
      returnVO.page = (accessPage === null || accessPage === undefined || accessPage === '') ? '1' : accessPage;
      returnVO.sortItem = this.kymw1300Component.kymw1300_03.selectedModel.accessSortItem;
      returnVO.sortOrder = this.kymw1300Component.kymw1300_03.selectedModel.accessSortOrder;
      returnVO.orderClientCode = this.kymw1300Component.kymw1300_03.selectedModel.orderClientCode;
      returnVO.orderClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.orderClientKanji;
      returnVO.payeeClientCode = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientCode;
      returnVO.payeeClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientKanji;
    } else {                                                                    // 上記以外の場合
      returnVO.dispMode = this.kymw1300Component.kymw1300_03.selectedModel.dispMode;
      returnVO.coopCode = this.kymw1300Component.kymw1300_03.cmb_CoopCode.selectedCoopCode;
      returnVO.sortItem = this.kymw1300Component.kymw1300_03.selectedModel.accessSortItem;
      returnVO.sortOrder = this.kymw1300Component.kymw1300_03.selectedModel.accessSortOrder;

      switch (returnVO.dispMode) {
        case '1':                                                               // 「1：部門」の場合
          returnVO.classCode = this.kymw1300Component.kymw1300_03.cmb_ClassCode.selectedClassCode;
          returnVO.middleClassCode = this.kymw1300Component.kymw1300_03.cmb_MiddleClassCode.selectedMiddleClassCode;
          returnVO.smallClassCode = this.kymw1300Component.kymw1300_03.cmb_SmallClassCode.selectedSmallClassCode;
          returnVO.pageNo = null;
          returnVO.buyerCode = null;

          if ('1' === this.senteiFlg) {
            this.kymw1300Component.kymw1300_03.selectedModel.orderClientCode = null;
            this.kymw1300Component.kymw1300_03.selectedModel.orderClientKanji = null;
            this.kymw1300Component.kymw1300_03.selectedModel.payeeClientCode = null;
            this.kymw1300Component.kymw1300_03.selectedModel.payeeClientKanji = null;
          }

          returnVO.orderClientCode = this.kymw1300Component.kymw1300_03.selectedModel.orderClientCode;
          returnVO.orderClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.orderClientKanji;
          returnVO.payeeClientCode = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientCode;
          returnVO.payeeClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientKanji;

          this.senteiFlg = '';
          break;

        case '2':                                                               // 「2：ページ」の場合
          returnVO.classCode = '';
          returnVO.middleClassCode = '';
          returnVO.smallClassCode = '';

          // ページIDのチェック
          if ('*' === this.kymw1300Component.kymw1300_03.cmb_PageNo.selectedPageId) {
            returnVO.pageNo = 'ALL';
          } else if ('-' === this.kymw1300Component.kymw1300_03.cmb_PageNo.selectedPageId) {
            returnVO.pageNo = 'NOT';
          } else {
            returnVO.pageNo = this.kymw1300Component.kymw1300_03.cmb_PageNo.selectedPageNum;
          }

          returnVO.buyerCode = null;
          returnVO.orderClientCode = null;
          returnVO.orderClientKanji = null;
          returnVO.payeeClientCode = null;
          returnVO.payeeClientKanji = null;
          break;

        case '3':                                                               // 「3：バイヤー」の場合
          returnVO.classCode = '';
          returnVO.middleClassCode = '';
          returnVO.smallClassCode = '';
          returnVO.pageNo = null;
          returnVO.buyerCode = this.kymw1300Component.kymw1300_03.cmb_buyerCode.selectedCodeValue;
          returnVO.orderClientCode = this.kymw1300Component.kymw1300_03.selectedModel.orderClientCode;
          returnVO.orderClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.orderClientKanji;
          returnVO.payeeClientCode = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientCode;
          returnVO.payeeClientKanji = this.kymw1300Component.kymw1300_03.selectedModel.payeeClientKanji;
          break;

        default:
          break;
      }
    }

    // 検索条件VOを返却
    return returnVO;
  }

  /**
   * 次回案内自動設定APIリクエストVO初期化
   *
   * @returns {KYMW1300UpdateNextGuideAutoModel}
   * @memberof KYMW1300Component
   */
  public setUpdateNextGuideAutoVO(): KYMW1300UpdateNextGuideAutoModel {
    const pCodeList: Array<string> = new Array<string>();

    // Ｐコードリスト初期化処理
    for (const item of this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selectedItems) {
      pCodeList.push(item.PCode);
    }

    // 次回案内自動設定APIリクエストVO初期化
    const returnVO: KYMW1300UpdateNextGuideAutoModel = new KYMW1300UpdateNextGuideAutoModel();
    returnVO.mediumType = this.mediumType;
    returnVO.pCodeList = pCodeList;
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }

    // VOを返却
    return returnVO;
  }

  /**
   * 選定解除APIリクエストVO初期化
   *
   * @returns {KYMW1300DeletePlanModel}
   * @memberof KYMW1300Component
   */
  public setDeletePlanVO(): KYMW1300DeletePlanModel {
    const pCodeList: Array<string> = new Array<string>();

    // Ｐコードリスト初期化処理
    for (const item of this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selectedItems) {
      pCodeList.push(item.PCode);
    }

    // 次回案内自動設定APIリクエストVO初期化
    const returnVO: KYMW1300DeletePlanModel = new KYMW1300DeletePlanModel();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode;
      returnVO.bundleCatalogRoundId = this.BundleCatalogRoundId;
    }
    returnVO.mediumType = this.mediumType;
    returnVO.pCodeList = pCodeList;

    // VOを返却
    return returnVO;
  }

  /**
   * 企画連絡承認画面InputVO初期化
   *
   * @returns {KYMW1317InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1317InputVO(): KYMW1317InputModel {
    const returnVO: KYMW1317InputModel = new KYMW1317InputModel();
    //受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
    } else {
      //受注コードが未入力の場合、束ね企画開回始受注コードを設定
      returnVO.orderCode = this.startOrderCode
    }
    returnVO.pCodeList.push(this.getSelectedPCode());
    returnVO.MediumType =
      this.kymw1300Component.kymw1300_03.selectedModel.
        selectedList[this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selection.row].MediumType;
    if (!this.kymw1300Component.kymw00Model.kymw1001Model.topFuncReadOnlyMode) {
      returnVO.UserPermission = '0';
    } else {
      returnVO.UserPermission = '1';
    }
    return returnVO;
  }

  /**
   * 特集付替設定画面InputVO初期化
   *
   * @returns {KYMW1319InputModel}
   * @memberof KYMW1300Model
   */
  public setKYMW1319InputVO(): KYMW1319InputVO {
    const returnVO = new KYMW1319InputVO();
    // 受注コードが入力済の場合
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Component.txt_OrderCode.selectedOrderCode)) {
      returnVO.orderCode = this.kymw1300Component.txt_OrderCode.selectedOrderCode;
      returnVO.progressWorkNum = this.getProgressWorkNum(this.catalogProgress, this.mediumType);
    }
    // 束ねフラグが'1'(束ね企画対象)の媒体が選択されている場合(束ね企画名が選択済みの場合)
    if (!PlessViewUtilsSub.isEmpty(this.bundleCatalogGuideStandardName)) {
      returnVO.startOrderCode = this.startOrderCode;
    }
    
    returnVO.pcode = this.getSelectedPCode();
    const selectedMediumTypeList = this.mediumTypeList.find(item => item.MediumType === this.mediumType);
    returnVO.mediumType = this.mediumType;
    returnVO.mediumName = selectedMediumTypeList.MediumName;
    returnVO.guideGoodsName = this.kymw1300Component.kymw1300_03.dg_SelectedItemList.selectedItems[0].GuideGoodsName;
    returnVO.editLockFlag = this.editLock ? '1': '0';
    returnVO.bundleCatalogFlag = selectedMediumTypeList.BundleCatalogFlag;
    return returnVO;
  }

  /**
   * 選択媒体の業態区分がウィークリーか判定する。
   *
   * @returns {boolean} 判定結果(true：ウィークリーである、false：ウィークリーでない)
   */
  public isDutiesFormWeekly(): boolean {
    const selectedMediumTypeList: MediumTypeModel | undefined = this.mediumTypeList.find(
      item => item.MediumType === this.mediumType
    );
    if (selectedMediumTypeList !== undefined) {
      if (!PlessViewUtilsSub.isEmptyArray([selectedMediumTypeList])) {
        // 選択媒体の業態区分のチェック 
        if (selectedMediumTypeList.DutiesFormDiv === this.kymw1300Component.kymw00Model.DUTIES_FORM_DIV_WEEKLY) {
          // 判定結果(ウィークリーである)を返却
          return true;
        }
      }
    }

    // 判定結果(ウィークリーでない)を返却
    return false;
  }

  /**
   * 選択媒体の業態区分がウィークリーかいつでも注文か判定する。
   *
   * @returns {boolean} 判定結果(true：ウィークリーもしくはいつでも注文である、
   *                            false：ウィークリーでもいつでも注文でもない)
   */
  public isDutiesFormWeeklyOrDivPeriod(): boolean {
    const selectedMediumTypeList: MediumTypeModel | undefined = this.mediumTypeList.find(
      item => item.MediumType === this.mediumType
    );
    if (selectedMediumTypeList !== undefined) {
      if (!PlessViewUtilsSub.isEmptyArray([selectedMediumTypeList])) {
        // 選択媒体の業態区分のチェック 
        if (selectedMediumTypeList.DutiesFormDiv === this.kymw1300Component.kymw00Model.DUTIES_FORM_DIV_WEEKLY ||
          selectedMediumTypeList.DutiesFormDiv === this.kymw1300Component.kymw00Model.DUTIES_FORM_DIV_PERIOD) {
          // 判定結果(ウィークリーもしくはいつでも注文である)を返却
          return true;
        }
      }
    }

    // 判定結果(ウィークリーでもいつでも注文でもない)を返却
    return false;
  }

  /**
   * 選択媒体の媒体グループ区分が通常媒体もしくは在庫限定か判定する。
   *
   * @returns {boolean} 判定結果(true：通常媒体もしくは在庫限定である、false：通常媒体もしくは在庫限定でない)
   */
  public isGroupNormalOrStock(): boolean {
    const selectedMediumTypeList: MediumTypeModel | undefined = this.mediumTypeList.find(
      item => item.MediumType === this.mediumType
    );
    if (selectedMediumTypeList !== undefined) {
      if (!PlessViewUtilsSub.isEmptyArray([selectedMediumTypeList])) {
        if (selectedMediumTypeList.MediumGroupDiv === this.kymw1300Component.kymw00Model.MEDIUM_GROUP_DIV_NORMAL ||
          selectedMediumTypeList.MediumGroupDiv === this.kymw1300Component.kymw00Model.MEDIUM_GROUP_DIV_STOCK) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 選択媒体の媒体グループ区分が通常媒体か判定する。
   *
   * @returns {boolean} 判定結果(true：通常媒体、false：通常媒体でない)
   */
  public isGroupNormal(): boolean {
    const selectedMediumTypeList: MediumTypeModel | undefined = this.mediumTypeList.find(
      item => item.MediumType === this.mediumType
    );
    if (selectedMediumTypeList !== undefined) {
      if (!PlessViewUtilsSub.isEmptyArray([selectedMediumTypeList])) {
        if (selectedMediumTypeList.MediumGroupDiv === this.kymw1300Component.kymw00Model.MEDIUM_GROUP_DIV_NORMAL) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * 工程管理Noを取得する
   * 
   * @param mediumType 
   * @returns 
   */
  public getProgressWorkNum(catalogProgressList: KYMW1300CatalogProgressModel[], mediumType: string): string {
    let progressWorkNum = '';
    if (!PlessViewUtilsSub.isEmpty(mediumType)) {
      for (const item of catalogProgressList) {
        // 媒体区分、工程管理NOのチェック
        if (item.MediumType === mediumType) {
          progressWorkNum = item.ProgressWorkNum;
          break;
        }
      }
    }
    return progressWorkNum;
  }
}
